<template>
  <div v-if="!permission.capabilities.View" class="animated fadeIn content-holder"> 
    <Page403></Page403>
  </div>
  <div v-else class="animated fadeIn content-holder">
    <b-card>
      <b-card-header class="custom-header">
        <div>
          <i class="icon-people mr-1"></i>Wallet Segment List
        </div>
        <router-link to="/wallet-segments/new" :event="permission.capabilities.Create ? 'click' : ''">
          <b-button variant="primary" :disabled="!permission.capabilities.Create">
            <i class="fa fa-plus"></i>&nbsp;New
          </b-button>
        </router-link>
      </b-card-header>
      <b-card-body v-if="isLoading">
        <spinner></spinner>
      </b-card-body>
      <b-card-body v-else>
        <v-client-table
          :columns="columns"
          :data="data"
          :options="options"
          :theme="theme"
          id="dataTable"
        >
          <a
            slot="title"
            class="hyperlink-without-href"
            slot-scope="props"
            title="View"
            @click="openEditPage(props.row.id)"
          >{{props.row.title}}</a>
          <c-switch
            slot="active"
            data-on=""
            data-off=""
            disabled
            slot-scope="props"
            color="success"
            class="mx-1 active-disabled"
            :checked="props.row.active"
            label
          />
          <c-switch
            slot="published"
            data-on=""
            data-off=""
            disabled
            slot-scope="props"
            color="success"
            class="mx-1 active-disabled"
            :checked="props.row.published"
            label
          />

          <div slot="action" slot-scope="props">
            <div class="input-group input-group-sm action">
              <b-dropdown variant="link" size="sm" no-caret v-if="!props.row.isLocked">
                <template slot="button-content">
                  <i class="fa fa-cog" aria-hidden="true"></i>
                </template>
                <b-dropdown-item
                  @click="openEditPage(props.row.id)"
                  :disabled="!permission.capabilities.Edit"
                >
                  <i class="fa fa-edit"></i>&nbsp;Edit
                </b-dropdown-item>
                <b-dropdown-item
                  @click="openDeleteModal(props.row.id)"
                  :disabled="!permission.capabilities.Delete"
                >
                  <span style="color: #20a8d8;">
                    <i class="fa fa-trash"></i>&nbsp;Delete
                  </span>
                </b-dropdown-item>
              </b-dropdown>

              <div v-if="props.row.isLocked">
                <b-button :id="`${props.row.walletSegment_id}_lock_msg`" variant="none">
                  <i class="fa fa-lock" aria-hidden="true" style="font-size:14px"></i>
                </b-button>
                <b-popover
                  :target="`${props.row.walletSegment_id}_lock_msg`"
                  title="Locked!"
                  triggers="hover focus"
                  placement="right"
                  content="This is locked. Edit/Delete Not available for now."
                ></b-popover>
              </div>
            </div>
          </div>

          <div slot="generateTechsStatus" slot-scope="props" class="techStatus">
            <div v-if="props.row.generateTechsStatus != 'Error'">
              <div v-if="props.row.isQrTech && props.row.isQrTechCreateQRImage">
                <div
                  v-if="props.row.tech_generation_info.qr.qr_generation_status != 'Error' && 
                            props.row.tech_generation_info.qr.qr_generation_status != 'qr_image_generation_no_need'"
                >
                  <b-button
                    size="sm"
                    variant="success"
                    v-on:click="(props.row.tech_generation_info.qr.qr_generation_status === 'Completed') ?
                                fileDownload(props.row.tech_generation_info.qr.zipped_qr_file_path, 'zip') : noAction(props.row.walletSegment_id)"
                  >
                    <i
                      v-if="props.row.tech_generation_info.qr.qr_generation_status === 'Not started'"
                      v-b-tooltip.hover
                      title="Not started (Initializing)"
                      class="fa fa-hourglass-start"
                    ></i>
                    <i
                      v-else-if="props.row.tech_generation_info.qr.qr_generation_status === 'Processing'"
                      v-b-tooltip.hover
                      :title="(props.row.tech_generation_info.qr.qr_generation_detail_status === 'NULL') ? 
                                props.row.tech_generation_info.qr.qr_generation_status : props.row.tech_generation_info.qr.qr_generation_detail_status"
                      class="fa fa-refresh fa-spin spinnerwhite"
                    ></i>

                    <i
                      v-else-if="props.row.tech_generation_info.qr.qr_generation_status === 'Completed'"
                      v-b-tooltip.hover
                      :title="props.row.tech_generation_info.qr.qr_generation_status"
                      class="fa fa-download spinnerwhite"
                    ></i>
                    &nbsp;QR
                  </b-button>
                </div>

                <div
                  v-else-if="props.row.tech_generation_info.qr.qr_generation_status === 'qr_image_generation_no_need'"
                >
                  <b-button variant="info" size="sm">
                    <i
                      class="fa fa-stop-circle-o"
                      style="font-size:16px;"
                      disabled
                      v-b-tooltip.hover
                      :title="props.row.tech_generation_info.qr.qr_available_action_msg"
                    ></i>
                    &nbsp;QR
                  </b-button>
                </div>
              </div>

              <!-- CSV !-->
              <div
                v-if="props.row.tech_generation_info.csv.csv_generation_status != 'Error'"
                :style="[props.row.isQrTechCreateQRImage ? {'padding-left': '10px'} : {'padding-left': '0px'}]"
              >
                <b-button
                  size="sm"
                  variant="success"
                  v-on:click="(props.row.tech_generation_info.csv.csv_generation_status === 'Completed') ?
                              fileDownload(props.row.tech_generation_info.csv.csv_file_path, 'csv') : noAction(props.row.walletSegment_id)"
                >
                  <i
                    v-if="props.row.tech_generation_info.csv.csv_generation_status === 'Not started'"
                    v-b-tooltip.hover
                    title="Not started (Initializing)"
                    class="fa fa-hourglass-start"
                  ></i>
                  <i
                    v-else-if="props.row.tech_generation_info.csv.csv_generation_status === 'Processing'"
                    v-b-tooltip.hover
                    :title="props.row.tech_generation_info.csv.csv_generation_status"
                    class="fa fa-refresh fa-spin spinnerwhite"
                  ></i>
                  <i
                    v-else-if="props.row.tech_generation_info.csv.csv_generation_status === 'Completed'"
                    v-b-tooltip.hover
                    :title="props.row.tech_generation_info.csv.csv_generation_status"
                    class="fa fa-download spinnerwhite"
                  ></i>
                  &nbsp;CSV
                </b-button>
              </div>
              <!-- CSV -->
            </div>
            <div v-else>
              <b-button size="sm" :id="`${props.row.walletSegment_id}_error`" variant="error">
                <i class="fa fa-exclamation-circle text-danger font-size-20"></i>
              </b-button>
              <b-popover
                :target="`${props.row.walletSegment_id}_error`"
                title="Error"
                triggers="hover focus"
                placement="right"
                :content="props.row.errorMessage"
              ></b-popover>
            </div>
          </div>
        </v-client-table>
      </b-card-body>
    </b-card>
    <DeleteConfirmModal
      v-bind:modalTitle="deleteModal.modalTitle"
      v-bind:modalMsg="deleteModal.modalMsg"
      v-bind:loginUserRoleName="deleteModal.loginUserRoleName"
      v-on:toggle="getDeleteAction($event)"
      ref="deleteConfirmModal"
    />
    <InfoModal ref="infoModal"></InfoModal>
  </div>
</template>

<script>
import Vue from "vue";
import miniToastr from "mini-toastr";
import { Switch as cSwitch } from "@coreui/vue";
import VueNotifications from "vue-notifications";
import { ClientTable, Event } from "vue-tables-2";
import { apigClient } from "@/shared/api";
import { router } from "../../router/index";
import moment from "moment";
import "moment-timezone";
import DeleteConfirmModal from "./../custom-components/DeleteConfirmModal";
import InfoModal from "@/shared/Modals.vue";
import Page403 from "@/views/pages/Page403.vue";

// Graphql query
import segmentsThatAreNotInCompleteStateQuery from "@/graphql/SegmentsThatAreNotInCompleteStateQuery";
import segmentsUpdateSubscribeQuery from "@/graphql/SegmentsUpdateSubscribeQuery";

const Spinner = () => import("../shared/Spinner");
const axios = require("axios");

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb);
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};
//  VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options);
Vue.use(ClientTable);

//Column's customization
let columns = [
  "action",
  "walletSegmentName",
  "segmentCount",
  "createdAt",
  "active",
  "published",
  "generateTechsStatus"
];

let headings = {
  action: "",
  walletSegmentName: "Name",
  segmentCount: "Count",
  createdAt: "Created",
  active: "Active",
  published: "Published",
  generateTechsStatus: "Tech Status"
};
let sortable = ["walletSegmentName", "segmentCount", "createdAt"];
let filterable = ["walletSegmentName", "segmentCount"];

//Export component
export default {
  name: "WalletSegments",
  components: {
    cSwitch,
    ClientTable,
    Spinner,
    Event,
    DeleteConfirmModal,
    InfoModal,
    Page403
  },
  data: function() {
    let loginUserInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
    let userTimezone = loginUserInfo.db.timezone || "Asia/Bangkok";
    return {
      loginUserInfo: loginUserInfo,
      permission: {
        permissionBaseName: null,
        permissionBaseNameCapabilities: null,
        capabilities: {
          View: false,
          Edit: false,
          Delete: false,
          Create: false,
        }
      },
      userTimezone: userTimezone,
      graphqlWalletSegmentsData: null,
      isLoading: true,
      columns: columns,
      data: [],
      options: {
        columnsClasses: "left-align",
        headings: headings,
        sortable: sortable,
        filterable: filterable,
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          chunk: 5,
          edge: false,
          nav: "scroll"
        }
      },
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
      deleteModal: {
        modalTitle: "Delete Wallet Segment",
        modalMsg: "",
        loginUserRoleName: loginUserInfo.db.roleName,
        deleteAction: ""
      },
      id: null,
      title: null,
      wallet_segment_id: null,
      companyId: null
    };
  },
  apollo: {
    segmentsThatAreNotInCompleteStateQuery: {
      query: segmentsThatAreNotInCompleteStateQuery,
      variables() {},
      fetchPolicy: "cache-and-network",
      result({ data, loading, error, segmentsThatAreNotInCompleteStateQuery }) {
        if (!loading && !error && data) {
          this.graphqlWalletSegmentsData =
            data.listConnect2WalletSegments.items;
          console.log(
            "First time graphql loaded objSegment list (Not in completed state) : ",
            this.graphqlWalletSegmentsData
          );
        }
      },
      error(error) {
        console.error(
          "We've got an error while fetching wallet Segments from AWS AppSync GraphQL!",
          error
        );
      },
      update: function(data) {
        if (data.listConnect2WalletSegments.items.length > 0) {
          this.graphqlWalletSegmentsData =
            data.listConnect2WalletSegments.items;
          this.graphqlWalletSegmentsData.forEach(liveUpdatedWalletSeg => {
            let walletSegInList = this.data.find(
              walletSeg =>
                walletSeg.walletSegment_id === liveUpdatedWalletSeg.id
            );
            if (walletSegInList != null && walletSegInList != undefined) {
              walletSegInList.errorMessage = liveUpdatedWalletSeg.errorMessage
                ? liveUpdatedWalletSeg.errorMessage
                : walletSegInList.errorMessage;
              walletSegInList.generateTechsStatus = liveUpdatedWalletSeg.generateTechsStatus
                ? liveUpdatedWalletSeg.generateTechsStatus
                : walletSegInList.generateTechsStatus;
              walletSegInList.tech_generation_info = liveUpdatedWalletSeg.tech_generation_info
                ? JSON.parse(liveUpdatedWalletSeg.tech_generation_info)
                : walletSegInList.tech_generation_info;
              walletSegInList.isLocked =
                liveUpdatedWalletSeg.isLocked != null &&
                liveUpdatedWalletSeg.isLocked != undefined
                  ? liveUpdatedWalletSeg.isLocked
                  : walletSegInList.isLocked;
            }
          });
        }
      }
    }
  },
  methods: {
    getPermission(){
      let that = this;
      const userPermissionsBasedOnEntity = that.loginUserInfo.db.userPermissionsBasedOnEntity;
      if(this.$route.meta && userPermissionsBasedOnEntity){
        that.permission.permissionBaseName = this.$route.meta.permissionBaseName;
        let userPermissionBasedOnEntity = userPermissionsBasedOnEntity.find(p => p.permissionBaseName === this.$route.meta.permissionBaseName);
        if(userPermissionBasedOnEntity){
          that.permission.permissionBaseNameCapabilities = userPermissionBasedOnEntity.capabilities;
          that.permission.permissionBaseNameCapabilities.forEach(capability=>{
            that.permission.capabilities[capability.label] = capability.value
          });
        }
      } else{
        router.push('/no-permission-given');
      }
      console.log('permission: ' , that.permission);
    },
    loadSegmentsThatAreNotInCompletedState_FromAppSync() {
      // start a subscription
      this.$apollo
        .subscribe({
          query: segmentsUpdateSubscribeQuery
        })
        .subscribe({
          next(liveData) {
            if (liveData) {
              console.log("Live Update data=", liveData);
            }
          },
          error(err) {
            console.error(
              "We've got an error while fetching wallet Segments live updates from AWS AppSync GraphQL!",
              err
            );
          }
        });
    },
    openDeleteModal: function(id) {
      let that = this;
      that.deleteModal.deleteAction = "";
      that.id = id;
      that.wallet_segment_id = that.data[id].walletSegment_id;
      that.companyId = that.data[id].company_id;
      that.title = that.data[id].walletSegmentName;
      that.deleteModal.modalMsg =
        "Delete the Wallet Segment '" + that.title + "' ?";
      that.$refs.deleteConfirmModal.openModal();
    },
    openEditPage: function(id) {
      let that = this;
      that.id = id;
      that.wallet_segment_id = that.data[id].walletSegment_id;
      localStorage.setItem("page_wallet_segment_id", that.wallet_segment_id);
      router.push({ name: "walletSegmentEdit" });
    },
    loadAndUpdateTableListAfterItemDelete: function(that) {
      Vue.delete(that.data, that.id);
    },
    getDeleteAction(data) {
      let that = this;
      console.log(data);
      if (data && data.deleteAction) {
        that.deleteModal.deleteAction = data.deleteAction;
        that.deleteWalletSeg();
      }
    },
    changeInfoModalContent(status = null, title = null, message = null) {
      let that = this;
      that.$refs.infoModal.status = status
        ? status
        : that.$refs.infoModal.status;
      that.$refs.infoModal.title = title ? title : that.$refs.infoModal.title;
      that.$refs.infoModal.message = message
        ? message
        : that.$refs.infoModal.message;
    },
    fileDownload: function(fileUrl, fileType) {
      if (fileUrl != "NULL") {
        window.open(fileUrl);
      } else {
        this.showWarnMsg({message: 'No URL Defined!'});
      }
    },
    noAction: function(walletSegment_id) {
      console.log("No Action for " + walletSegment_id);
    },
    loadWalletSegments: function(companyId) {
      console.log('companyId ' + companyId);
      var method = "GET";
      var pathTemplate = "/wallet-segments";
      let additionalParams = {
        queryParams: {
          params: JSON.stringify({
            filter: [
              {
                fieldname: "isDeleted",
                comparisonOperator: "=",
                value: false
              },
              {
                fieldname: "company_id",
                comparisonOperator: "=",
                value: this.companyId
              }
            ]
          })
        }
      };
      var pathParams = {};
      var userDatas = [];
      var that = this;
      apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result) {
          that.data = result["data"]["data"].map((elem, index) => {
            elem.walletSegment_id = elem.id;
            elem.id = index;
            elem.createdAt = moment(moment.unix(elem.createdAt))
              .tz(that.userTimezone)
              .format("YYYY-MM-DD HH:mm");
            elem.updateAt = moment(moment.unix(elem.updateAt))
              .tz(that.userTimezone)
              .format("YYYY-MM-DD HH:mm");
            //Determining qr tech
            let qrTechSegment = elem.chosenMainTechsAndConfigs.find(
              chosenMainTech => chosenMainTech.main_techProductName == "qr"
            );
            elem.isQrTech = qrTechSegment ? true : false;

            let qrTechCreateQRImage = elem.chosenMainTechsAndConfigs.find(
              chosenMainTech =>
                chosenMainTech.main_techProductName == "qr" &&
                chosenMainTech.tech_configs.create_qr_images
            );
            elem.isQrTechCreateQRImage = qrTechCreateQRImage ? true : false;

            return elem;
          });
          console.log("this.data=", that.data);
          that.isLoading = false;
        })
        .catch(function(error) {
          console.log("ERROR ! Cannot get data:" + error);
          that.showErrorMsg();
        });
    },
    deleteWalletSeg: function() {
      let that = this;
      that.$refs.infoModal.openModal();
      that.changeInfoModalContent(
        "loading",
        "Processing...",
        that.deleteModal.deleteAction == "MARK-AS-DELETED"
          ? "Deleting the Wallet Segment (" + that.title + ")"
          : "Deleting the Wallet Segment (" + that.title + ") permenently"
      );
      if (that.deleteModal.deleteAction == "MARK-AS-DELETED") {
        that.markWalletSegAsDeleted(that);
      } else {
        let wallet_segment_id = that.wallet_segment_id;
        let method = "DELETE";
        let pathTemplate =
          "/wallet-segments/" + wallet_segment_id + "/" + that.companyId;
        let additionalParams = {};
        let pathParams = {};
        apigClient
          .invokeApi(pathParams, pathTemplate, method, additionalParams)
          .then(function(result) {
            if (result.data.status) {
              console.log(
                "deleted the wallet segment, wallet_segment_id: " +
                  wallet_segment_id
              );
              that.changeInfoModalContent(
                "success",
                "Deleted success!",
                "The Wallet Segment has been deleted"
              );
              setTimeout(that.$refs.infoModal.closeModal(), 1500);
              that.showSuccessMsg();
              that.loadAndUpdateTableListAfterItemDelete(that);
            } else {
              console.log("Error From API Endpoint: " + result.data.message);
              that.changeInfoModalContent(
                "error",
                "Error Occured!",
                "Error From API Endpoint: " + result.data.message
              );
            }
          })
          .catch(function(error) {
            console.log("Error From API Endpoint: " + error.message);
            that.changeInfoModalContent(
              "error",
              "Error Occured!",
              "Error From API Endpoint: " + error.message
            );
          });
      }
    },
    markWalletSegAsDeleted: that => {
      let method = "PUT";
      let pathTemplate =
        "/wallet-segments/" + that.wallet_segment_id + "/mark-as-deleted";
      let additionalParams = {};
      let pathParams = {};
      let body = {
        updateBy: that.loginUserInfo.login_username
      };
      apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams, body)
        .then(function(result) {
          if (result.data.status) {
            console.log(result);
            that.changeInfoModalContent(
              "success",
              "Deleted success!",
              "The Wallet Segment data has been deleted"
            );
            setTimeout(that.$refs.infoModal.closeModal(), 1500);
            that.showSuccessMsg();
            that.loadAndUpdateTableListAfterItemDelete(that);
          } else {
            console.log("Error From API Endpoint: " + result.data.message);
            that.changeInfoModalContent(
              "error",
              "Error Occured!",
              "Error From API Endpoint: " + result.data.message
            );
          }
        })
        .catch(function(error) {
          that.changeInfoModalContent(
            "error",
            "Error Occured!",
            "Error From API Endpoint: " + error.message
          );
        });
    }
  },
  mounted: function() {
    let that = this;
    that.getPermission();
    if(!that.permission.capabilities.View){
      return;
    }

    const user = JSON.parse(localStorage.getItem('loginUserInfo'));
    this.companyId = (user.db.company.id == null || user.db.company.id == undefined || user.db.company.id == 'NULL') ? '' : user.db.company.id;
    that.loadSegmentsThatAreNotInCompletedState_FromAppSync();
    that.loadWalletSegments(this.companyId);
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: "Operation successfull!",
      message: "The wallet segment has been deleted"
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: "INFORMATION",
      message: "Here is some info for you"
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: "WARNING",
      message: "That's the kind of warning"
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: "ERROR",
      message: "Error! See console for additional error logs"
    }
  }
};
</script>
<style src="spinkit/scss/spinkit.scss" lang="scss" />

<style scoped>
.sk-fading-circle .sk-circle {
  margin: 0 auto;
}
.sk-three-bounce {
  height: 40px;
}

.card-body {
  padding: 0 !important;
}
</style>

<style lang="scss">
#dataTable {
  width: 95%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.25rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .action {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.custom-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btn-secondary {
  background-color: none;
}

.modal-dialog {
  color: black;
}

.container-fluid {
  margin: 0 !important;
  padding: 0 !important;
}

.breadcrumb {
  margin-bottom: 0;
  border-bottom: 0;
}
#dataTable {
  margin: 18px auto;
}

.hyperlink-without-href {
  color: #20a8d8 !important;
  text-decoration: none !important;
  background-color: transparent !important;
}
.hyperlink-without-href:hover {
  color: #20a8d8 !important;
  cursor: pointer;
  text-decoration: underline !important;
}
.active-disabled .switch-pill .switch-slider {
  opacity: 1 !important;
}
#dataTable th {
  text-align: left !important;
}
.admin-delete-actions {
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: center;
}
.margin-left-10 {
  margin-left: 10px;
}
.spinnerwhite {
  color: #ffffff;
  font-size: 20px !important;
}
.font-size-20 {
  font-size: 20px !important;
}
.techStatus {
  text-align: left;
}
.techStatus div {
  display: inline-block;
}
</style>
